import { CalendarMonth, Delete, Edit, Event, EventBusy } from "@mui/icons-material";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useAppContextController } from "context/AppContext";
import { SnackbarProvider, useSnackbar } from "notistack";
import { useState } from "react";
import { useQueryClient } from "react-query";

const AvailabilityRowActions = ({ row, onDelete, onViewEvents }) => {
  const queryClient = useQueryClient();

  return (
    <Grid container spacing={1}>
      <Grid item>
        <Tooltip title="Delete">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onDelete(row._id);
            }}
            color="error"
          >
            <Delete fontSize="large" />
          </IconButton>
        </Tooltip>
        <Tooltip title={row?.conflictingEvents?.length ? "Scheduled Interviews" : ""}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onViewEvents(e, row);
            }}
            color="warning"
            disabled={!row?.conflictingEvents?.length}
          >
            <Event fontSize="large" />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default AvailabilityRowActions;
